const common = require("lib/labels/_common");

// Home.groups
module.exports = {
  memberDependancesMsg: {
    en: "No dependencies",
    fr: "Pas de dépendances"
  },
  registrationsDependancesMsg: {
    en: "No dependencies",
    fr: "Pas de dépendances"
  },
  invitationsDependancesMsg: {
    en: "No dependencies",
    fr: "Pas de dépendances"
  },
  licencesDependancesMsg: {
    en: "Your group don't have any licence, please contact a manager",
    fr: "Votre groupe n'a aucune licence, contactez un manager pour en créer"
  },
  projectsDependancesMsg: {
    en: "To access this service, at least one licence is required",
    fr: "Pour acceder à ce service, vous devez avoir accès à au moins une licence"
  },
  profilesDependancesMsg: {
    en: "No dependencies",
    fr: "Pas de dépendances"
  },
  title:{
    en: "Groups",
    fr: "Groupes"
  },
  cards: {  
    etat: {
    en: "Ready",
    fr: "Prêt"
    },
    members: {
      title: {
        en: "Members",
        fr: "Membres"
      },
      manage: common.manage
    },
    registrations: {
      title: {
        en: "Registrations",
        fr: "Inscriptions"
      },
      manage: common.manage
    },
    guests: {
      title: {
        en: "Guests",
        fr: "Invités"
      },
      manage: common.manage
    },
    invitations: {
      title: {
        en: "Invitations",
        fr: "Invitations"
      },
      manage: common.manage
    },
    licences: {
      title: common.licences,
      manage: common.manage
    },
    projects: {
      title: common.projects,
      manage: common.manage
    },
    profiles: {
      title: {
        en: "Profiles",
        fr: "Profils"
      },
      manage: common.manage
    }
  },
  licences: require("./licences"),
  members: require("./members"),
  registrations: require("./registrations"),
  invitations: require("./invitations"),
  profiles: require("./profiles"),
  projects: require("./projects")
};
